import React, { useEffect, useState } from "react";
import expenseService from "../../services/owner-services/owner-property-expense";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
const MyRnetExpense = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today);

  const [propertyName, setPropertyName] = useState("");

  // For expense modal
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [expenseData, setExpenseData] = useState([]);
  const [expenseLoading, setExpenseLoading] = useState(false);

  useEffect(() => {
    fetchAuditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const fetchAuditData = async () => {
    setLoading(true);
    try {
      const payload = {
        pageLength: 100,
        pageNo: 1,
        fMonth: selectedDate.getMonth() + 1,
        fYear: selectedDate.getFullYear(),
        propertyGuid: "",
      };

      const response = await expenseService.posttPropertyRentExpense(payload);
      if (response?.data?.isSuccess) {
        const list = response.data.result;
        const arr = Array.isArray(list) ? list : list ? [list] : [];
        setData(arr);

        if (arr.length > 0 && arr[0].propertyName) {
          setPropertyName(arr[0].propertyName);
        }
      } else {
        setData([]);
        setPropertyName("");
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
      setPropertyName("");
    } finally {
      setLoading(false);
    }
  };

  // Fetch monthly expenses when Expense clicked
  const fetchMonthlyExpenses = async (propertyGuid) => {
    setExpenseLoading(true);
    try {
      const payload = {
        pageNo: 1,
        pageLenght: 10,
        fMonth: selectedDate.getMonth() + 1,
        fYear: selectedDate.getFullYear(),
        propertyGuid,
      };

      const res = await expenseService.getMonthlyExpenses(payload);
      if (res?.data?.result) {
        setExpenseData(res.data.result);
      } else {
        setExpenseData([]);
      }
    } catch (error) {
      console.error("Error fetching monthly expenses", error);
      setExpenseData([]);
    } finally {
      setExpenseLoading(false);
      setShowExpenseModal(true);
    }
  };

  const formatCurrency = (value) =>
    `Rs. ${Number(value).toLocaleString("en-IN")}`;
  const formatDated = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };
  return (
    <div>
      <h3>Revenue</h3>

      <Form className="mb-3 mt-4">
        <Row className="align-items-center">
          <Col sm={3}>
            <Form.Label>Select Month & Year</Form.Label>
            <Calendar
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.value)}
              view="month"
              dateFormat="mm/yy"
              showIcon
              maxDate={new Date()}
              className="w-100"
            />
          </Col>
        </Row>
      </Form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <Row>
          <Col xs={12}>
            <DataTable
              value={data}
              paginator
              rows={10}
              showGridlines
              stripedRows
            >
              <Column field="propertyName" header="Property Name" />
              <Column field="propertyLocation" header="Location" />
              <Column
                header="Property Rent"
                body={(rowData) => formatCurrency(Number(rowData.totalRent))}
              />
              <Column
                header="Expense"
                body={(rowData) => (
                  <Button
                    variant="link"
                    onClick={() => fetchMonthlyExpenses(rowData.propertyGuid)}
                  >
                    {formatCurrency(Number(rowData.ownerExpenses))}
                  </Button>
                )}
              />
              <Column
                header="Receivable Amount"
                body={(rowData) => {
                  const rentPerOwner = Number(rowData.totalRent);
                  const expensePerOwner = Number(rowData.ownerExpenses);
                  return formatCurrency(rentPerOwner - expensePerOwner);
                }}
              />
            </DataTable>
          </Col>
        </Row>
      )}

      {/* Expense Modal */}
      <Modal
        show={showExpenseModal}
        onHide={() => setShowExpenseModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedDate
              ? `${selectedDate.toLocaleString("en-US", {
                  month: "long",
                  year: "numeric",
                })} Expenses`
              : "Monthly Expenses"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {expenseLoading ? (
            <p>Loading expenses...</p>
          ) : expenseData.length > 0 ? (
            <DataTable value={expenseData} paginator rows={5} stripedRows>
              <Column field="natureOfExpense" header="Nature of Expense" />
              <Column field="propertyName" header="Property Name" />
              <Column
                field="expenseDate"
                header="Date"
                body={(rowData) => formatDated(rowData.expenseDate)}
              />
              <Column
                field="amount"
                header="Amount"
                body={(d) => formatCurrency(d.amount)}
              />

              <Column
                field="individualOwnerExpense"
                header="Expense"
                body={(d) => formatCurrency(d.individualOwnerExpense)}
              />
              <Column
                field="addedOn"
                header="Added on"
                body={(rowData) => formatDated(rowData.addedOn)}
              />
                   <Column field="note" header="Note" />
            </DataTable>
          ) : (
            <p>No expenses found for this month.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowExpenseModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MyRnetExpense;
